import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromEmailTask from '../email-task/email-task.reducer'
import { TagModule } from '../tag/tag.module'
import { EmailTaskRoutingModule } from './email-task-routing.module'
import { EmailTaskEffects } from './email-task.effects'
import { EmailTaskSerializer } from './email-task.serializer'
import { EmailTaskService } from './email-task.service'
import { EmailTaskFormComponent } from './form/form.component'

@NgModule({
    imports: [
        EmailTaskRoutingModule,
        TagModule,
        SharedModule,
        StoreModule.forFeature(fromEmailTask.FEATURE_NAME, fromEmailTask.emailTaskReducer),
        EffectsModule.forFeature([EmailTaskEffects])
    ],
    declarations: [EmailTaskFormComponent],
    exports: [EmailTaskFormComponent],
    providers: [
        EmailTaskService,
        {
            provide: EmailTaskSerializer,
            useClass: EmailTaskSerializer
        }
    ]
})
export class EmailTaskModule {}
